import { FC, Fragment } from 'react'
import { Button, Icon, Image, Link, Row, Text } from '@/client/components'
import * as S from './styles'
import { TableContentProps } from '../types'

export const TableContent: FC<TableContentProps> = ({
  heading,
  long_text,
  eco_tick,
  table_contents,
  table_header,
  table_columns_small_screen,
  button_text,
  link
}) => (
  <>
    <Row>
      <S.HeaderSection>
        <S.Sections>
          <Text size='xxlg' weight='semiBlack' lineHeight='1.4'>
            <span dangerouslySetInnerHTML={{ __html: heading }} />
          </Text>
        </S.Sections>
        <S.Sections>
          <Text lineHeight='1.3' color='black' size='md'>
            {long_text}
          </Text>
        </S.Sections>
        <Image src={eco_tick.url} width='350' height='215' />
      </S.HeaderSection>
    </Row>

    <Row>
      <S.TableHeader>
        {table_header.map(({ key, text }) => (
          <Fragment key={key}>
            <S.Sections>
              <Text size='md' lineHeight='1.4'>
                <span dangerouslySetInnerHTML={{ __html: text }} />
              </Text>
            </S.Sections>
          </Fragment>
        ))}
      </S.TableHeader>
    </Row>

    <S.Container>
      <Row>
        <S.Contents>
          {table_contents.map(
            ({ key, paper_image, paper_name, description, temp, recycled_text, origin_text, recommended_for }) => (
              <Fragment key={key}>
                <S.ContentsWrapper>
                  <S.TableContents>
                    <S.ImageWrapper>
                      <Image src={paper_image.url} width='190' height='150' />
                    </S.ImageWrapper>

                    <S.TextWrapper>
                      <Text weight='bold' size='lg'>
                        {paper_name}
                      </Text>
                      <Text size='sm'>{description}</Text>

                      <S.ButtonWrapper>
                        <Button kind='warning' className='button'>
                          <Link href={link} className='calculatorLink'>
                            <Text size='sm' margin='0'>
                              {button_text}
                            </Text>
                            <Icon name='arrow-right' />
                          </Link>
                        </Button>
                      </S.ButtonWrapper>
                    </S.TextWrapper>
                    <S.TextWrapper>
                      <Text size='xs'>
                        <span dangerouslySetInnerHTML={{ __html: temp }} />
                      </Text>
                    </S.TextWrapper>
                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: recycled_text }} />
                      </Text>
                    </S.TextWrapper>
                    <S.TextWrapper>
                      <Text size='sm'>{origin_text}</Text>
                    </S.TextWrapper>
                    <S.TextWrapper>
                      <Text size='sm'>{recommended_for}</Text>
                    </S.TextWrapper>
                  </S.TableContents>
                  <S.Divider></S.Divider>
                </S.ContentsWrapper>
              </Fragment>
            )
          )}
        </S.Contents>
        <>
          {table_columns_small_screen.map(
            ({ key, row_1, row_2, row_3, row_4, row_5, row_6, row_7, row_8, row_9, row_10, row_11, row_12 }) => (
              <S.SmallScreenContentWrapper key={key}>
                <Fragment key={key}>
                  <S.SmallScreenContent>
                    <Text size='md' lineHeight='1.4'>
                      <span dangerouslySetInnerHTML={{ __html: row_1 }} />
                    </Text>
                    <S.ImageWrapper>
                      <Image src={row_2.url} width='190' height='150' />
                    </S.ImageWrapper>
                    <Text weight='bold' size='lg'>
                      <span dangerouslySetInnerHTML={{ __html: row_3 }} />
                    </Text>
                    <S.TextWrapper>
                      <Text size='sm'>
                        {' '}
                        <span dangerouslySetInnerHTML={{ __html: row_4 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: row_5 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: row_6 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: row_7 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>{row_8}</Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: row_9 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>{row_10}</Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>
                        <span dangerouslySetInnerHTML={{ __html: row_11 }} />
                      </Text>
                    </S.TextWrapper>

                    <S.TextWrapper>
                      <Text size='sm'>{row_12}</Text>
                    </S.TextWrapper>
                  </S.SmallScreenContent>

                  <S.ButtonWrapper>
                    <Button kind='warning' className='button'>
                      <Link href={link} className='calculatorLink'>
                        <Text size='sm' margin='0'>
                          {button_text}
                        </Text>
                        <Icon name='arrow-right' />
                      </Link>
                    </Button>
                  </S.ButtonWrapper>
                  <S.Divider></S.Divider>
                </Fragment>
              </S.SmallScreenContentWrapper>
            )
          )}
        </>
      </Row>
    </S.Container>
  </>
)
